import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@components/atoms/Button";

import useMeta from "@hooks/reducerHooks/useMeta";

import { URLS } from "@const/urls";

function NotFound() {
  const navigate = useNavigate();

  const { setMetaTag } = useMeta();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - NOT FOUND` });
  }, []);

  return (
    <div className="col-span-12 -ml-4 -mt-5 flex h-screen w-screen flex-col items-center justify-center bg-notFound bg-cover bg-center bg-no-repeat pc:-ml-5">
      <span className="pc:text-5xl mb-2.5 font-tune text-4xl leading-tight text-white"> WHOOPS!</span>
      <span className="mb-5 font-normal text-white">404 Page Not Found</span>
      <Button
        onClick={() => {
          navigate(URLS.HOME);
        }}
        styleType="secondary"
      >
        Back to Home
      </Button>
    </div>
  );
}

export default NotFound;
